import React from 'react';
import BaseIcon from '@material-ui/icons/AddCircle';

const AddCircle = (props) => <BaseIcon {...props} />;

export default AddCircle;
